import { render, staticRenderFns } from "./v-sidebar.vue?vue&type=template&id=0075e7ce&scoped=true"
import script from "./v-sidebar.vue?vue&type=script&lang=js"
export * from "./v-sidebar.vue?vue&type=script&lang=js"
import style0 from "./v-sidebar.vue?vue&type=style&index=0&id=0075e7ce&prod&lang=scss&scoped=true"
import style1 from "./v-sidebar.vue?vue&type=style&index=1&id=0075e7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0075e7ce",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VExpansionPanelHeader: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelHeader.js').default,VCheckbox: require('/app/node_modules/vuetify/lib/components/VCheckbox/VCheckbox.js').default,VExpansionPanelContent: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanelContent.js').default,VExpansionPanel: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanel.js').default,VExpansionPanels: require('/app/node_modules/vuetify/lib/components/VExpansionPanel/VExpansionPanels.js').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VCheckbox,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
